var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48.778,
    r: 48,
    fill: "#D0E3D1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s6d52sy6ca)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.77 33.877A16.363 16.363 0 0 0 29.223 46.4c3.008 5.401 8.631 8.455 14.414 8.455 2.71 0 5.456-.668 7.985-2.078 7.934-4.418 10.795-14.464 6.377-22.399C53.58 22.442 43.534 19.581 35.599 24a16.358 16.358 0 0 0-7.828 9.877zm8.227-9.164a15.538 15.538 0 0 1 7.586-1.972c5.496 0 10.841 2.898 13.698 8.034 4.197 7.537 1.48 17.087-6.058 21.284-7.537 4.197-17.087 1.48-21.284-6.058a15.554 15.554 0 0 1-1.377-11.898A15.539 15.539 0 0 1 36 24.717l-.004-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.774 72.683a1.024 1.024 0 0 0-1.394-.398l-.324.18-7.23-12.988.324-.18c.238-.131.41-.353.488-.615a1.032 1.032 0 0 0-.09-.779l-1.783-3.2c7.705-6.677 9.705-17.87 4.721-26.822a21.46 21.46 0 0 0-12.955-10.267 21.455 21.455 0 0 0-16.428 1.902A21.46 21.46 0 0 0 22.836 32.47a21.447 21.447 0 0 0 1.902 16.424 21.46 21.46 0 0 0 12.956 10.267 21.525 21.525 0 0 0 12.333-.148l1.778 3.197c.267.475.918.66 1.394.398l.422-.234 7.23 12.989-.422.233c-.238.131-.41.353-.488.615a1.03 1.03 0 0 0 .09.779l1.816 3.258c.18.324.525.525.893.525.173 0 .345-.045.496-.132l5.943-3.311c.238-.131.41-.353.488-.615.074-.262.041-.541-.09-.779l-1.816-3.258.013.004zm-18.64-53.692a20.039 20.039 0 0 1 12.098 9.587c5.41 9.713 1.906 22.018-7.808 27.428-9.713 5.41-22.017 1.905-27.428-7.808a20.04 20.04 0 0 1-1.774-15.333 20.02 20.02 0 0 1 9.586-12.095 20.07 20.07 0 0 1 9.78-2.558c1.852 0 3.721.259 5.55.779h-.005zm4.684 37.732a21.148 21.148 0 0 0 2.508-1.644l1.763 3.169-5.23 2.91-1.763-3.169a21.485 21.485 0 0 0 2.722-1.266zm3.45 2.918 7.83 14.063-2.694 1.5-7.828-14.063 2.693-1.5zm9.448 14.1 1.414 2.54-5.23 2.91-1.414-2.54 5.23-2.91z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s6d52sy6ca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(22 16.778)",
    d: "M0 0h47.716v64H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.355d899b04c853048460ffeaca9eb341.svg";
export { ForwardRef as ReactComponent };